<template>
  <div class="row items-center q-ml-md" v-if="value" @click.stop>
    <div class="row items-start">
      <q-input
        @click.stop
        @keyup.stop
        dense
        style="width: 100px"
        type="number"
        filled
        label="年份"
        v-model="value.year"
        :error="!!yearError"
        :error-message="yearError"
        @input="checkYear"
      />
      <span style="line-height: 40px" class="q-ml-sm">年</span>
    </div>

    <div class="row items-start q-ml-md" v-if="level !== 'year'">
      <q-input
        style="min-width: 80px"
        @click.stop
        @keyup.stop
        dense
        type="number"
        filled
        label="月份"
        :min="1"
        :max="12"
        v-model="value.month"
        :error="!!monthError"
        :error-message="monthError"
        @input="checkMonth"
      />
      <span style="line-height: 40px" class="q-ml-sm">月</span>
    </div>

    <div class="row items-start q-ml-md" v-if="level === 'date'">
      <q-input
        @click.stop
        @keyup.stop
        dense
        type="number"
        filled
        label="日期"
        v-model="value.date"
        :error="!!dateError"
        :error-message="dateError"
        @input="checkDate"
      />
      <span style="line-height: 40px" class="q-ml-sm">日</span>
    </div>
  </div>
</template>

<script>
import QuestionChoiceMixin from "./question-choice.mixin";
export default {
  mixins: [QuestionChoiceMixin],

  data() {
    return {
      yearError: "",
      monthError: "",
      dateError: "",
    };
  },

  watch: {
    checked(ckd) {
      if (ckd) {
        setTimeout(() => {
          this.$nextTick(() => {
            const { conf } = this;
            const config = (conf || {}).config || {};
            const level = config.level || "year";
            this.checkYear(this.value.year || "");
            if (level !== "year")
              this.checkMonth(this.value.month || "");
            if (level === "date") this.checkDate(this.value.date || "");
          });
        }, 0);
      } else {
        setTimeout(() => {
          this.$nextTick(() => {
            this.yearError = "";
            this.monthError = "";
            this.dateError = "";
          });
        }, 0);
      }
    },
  },

  computed: {
    level() {
      return ((this.conf || {}).config || {}).level || "date";
    },

    errorTextDict() {
      const { yearError, monthError, dateError } = this;
      return {
        yearError,
        monthError,
        dateError,
      };
    },
  },

  beforeMount() {
    if (!this.value) this.$emit("change", {});
    else {
      if (this.value.year !== undefined) {
        this.checkYear(this.value.year);
      }
      if (this.value.month !== undefined) {
        this.checkMonth(this.value.month);
      }
      if (this.value.date !== undefined) {
        this.checkDate(this.value.date);
      }
    }
  },

  methods: {
    checkYear(year) {
      if (!this.checked) {
        this.yearError = "当前选项未选中，输入无效";
        return;
      }

      if (year.length > 4) {
        this.yearError = "年份不得超过4位";
        return;
      }

      if (year.length < 4) {
        this.yearError = "请输入4位数";
        return;
      }

      if (parseInt(year) < 1000 || parseInt(year) > 9999) {
        this.yearError = "请输入4位整数";
        return;
      }

      if (!/^[1|2][0-9][0-9][0-9]$/.test(year)) {
        this.yearError = "年份格式有误";
        return;
      }

      if (this.conf && this.conf.config && this.conf.config.year_max) {
        const max = this.conf.config.year_max;
        if (parseInt(year) > max) {
          this.yearError = `年份不能超过${max}`;
          return;
        }
      }

      this.yearError = "";
    },

    checkMonth(month) {
      if (!this.checked) {
        this.monthError = "当前选项未选中，输入无效";
        return;
      }
      if (
        parseInt(month) < 1 ||
        parseInt(month) > 12 ||
        !/[1-9]+/.test(month)
      ) {
        this.monthError = "请输入正确的月份";
        return;
      }

      this.monthError = "";
    },

    checkDate() {},
  },
};
</script>
